import React from 'react';
import Button from '@material-ui/core/Button';
import { useFormikContext } from 'formik';

const ViewButton = ({inspectionReports}) => {
  const { values } = useFormikContext();
  const filterLink = inspectionReports.data.find(r => new Date(r.date).toLocaleString() === values.Revisions.split(" - ")[1]);
  const link = filterLink ? filterLink.url : "#";


  return <Button
    variant="contained"
    style={{ width: "100%", height: "100%" }}
    component="a"
    target="_blank"
    href={link}
    disabled={link.length < 5}
  >
    View
  </Button>
};

export default ViewButton;